import React, { useState } from 'react';

const Context = React.createContext();

function ContextProvider({ children }) {
    const [maskTheme, setMaskTheme] = useState('even3');
    const [gridTheme, setGridTheme] = useState('trail');
    const [animation, setAnimation] = useState('hide');
    const [domGame, setDomGame] = useState('tetris');

    function handleRadioSelection(event) {
        let {name, value} = event.target;

        switch(name){
            case 'maskTheme':
                setMaskTheme(value);
                break;
            case 'gridTheme':
                setGridTheme(value);
                break;
            case 'animation':
                setAnimation(value);
                break;
            case 'domGame':
                setDomGame(value);
                break;
            default: return;
        }
    }
    
    const data = {
        gridTheme,
        animation,
        maskTheme,
        domGame,
        handleRadioSelection
        }
        return (
            <Context.Provider value={data}>
                {children}
            </Context.Provider>
        )
    
}

export {ContextProvider, Context}